// HU-32a (MG-ILE-63) · tarea 32a-6. La sesión que DERIVA EL SERVIDOR (AT S3 §2.2.1).
//
// `GET /sesion` es la ÚNICA fuente del menú, del aterrizaje y de la cabecera
// (`estandares_frontend.md` §8.1 R4). Reemplaza a `PERMISOS[rol]` y `LANDING[rol]`, que eran una
// lista propia del frontend y la causa de los bugs 906, 714 y 900: el menú ofrecía pantallas que el
// servidor negaba. Aquí no se calcula nada: se pinta lo que llega.
//
// Nombres del contrato: `rutas_de_sesion.py::SesionSalida`.

import { pedir } from './cliente';

/** Un rol de la persona con SU ámbito (multi-rol: permisos = unión; ámbito por rol, RN-60). */
export type RolDeLaSesion = {
  rol: string;
  texto_del_rol: string;
  /** ISO-2. Vacío = corporativo. */
  paises: string[];
  texto_del_ambito: string;
};

export type SesionDelServidor = {
  usuario_id: string | null;
  usuario: string;
  correo: string;
  cargo: string | null;
  es_externo: boolean;
  texto_de_la_cabecera: string;
  roles: RolDeLaSesion[];
  /** Códigos de la tabla `modulo` (`bandeja`, `registro`, `admin`…): la unión de los roles. */
  modulos_permitidos: string[];
  modulo_inicial: string | null;
  tiene_permiso_l2: boolean;
  tiene_acceso: boolean;
  contacto_administrador: { nombre: string; correo: string } | null;
  /** HU-32a-C4, armado por el servidor. La pantalla lo pinta tal cual. */
  texto_sin_acceso: string | null;
};

export function consultarSesion() {
  return pedir<SesionDelServidor>('/sesion');
}

/** HU-32a-C6: una vez, tras volver de `loginRedirect`. Vincula el `oid` y deja el asiento. */
export function iniciarSesion() {
  return pedir<SesionDelServidor>('/sesion/inicio', { metodo: 'POST' });
}
